export default {
  columns: {
    employmentInsuranceLoss: 'Employment insurance loss notification',
    separationCertificate: 'Separation certificate',
    target: 'Target person'
  },
  eligibility: {
    applicable: 'Applicable',
    notApplicable: 'Not applicable'
  },
  filterTabs: {
    all: 'All',
    confirmed: 'Confirmed',
    pending: 'Pending'
  },
  filterTabsAriaLabel: 'Filter by confirmation status',
  loadError: 'Failed to load document information',
  loadErrorDescription: 'Please try again later.',
  missingInfo: 'Missing information',
  missingInfoDescription: 'Select targets before opening this screen.',
  separationCertificate: {
    doNotIssue: 'Do not issue',
    issue: 'Issue'
  },
  title: '{{packageTypeName}} - Confirm submission documents and separation certificate preference'
};